import { useMutation } from '@tanstack/react-query'
import { cancelShift } from 'api/shift'
import { AxiosError } from 'axios'
import { useAuthContext } from 'components/auth'

export function useCancelShiftMutation(options: {
  shiftId: number
  onSuccess?: () => void
  onError?: (err: AxiosError) => void
}) {
  const { shiftId, ...otherOptions } = options
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async () => {
      if (!company?.id) {
        return
      }

      return cancelShift(company.id, shiftId)
    },
    ...otherOptions,
  })
}
